import backToOffice from "../../services/auth/backToOffice";
import LoginService from "../../services/auth/Login";



export const StringValidate = async (string, code) => {
    try {
        const response = await backToOffice.accessToken(string, code)
        return response
    } catch (error) {
        console.log(error);
    }
}

export const ForgotPassword = async (data) => {
    try {
        const response = await LoginService.forgotPassword(data);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const VerifyForgotPassword = async (data) => {
    try {
        const response = await LoginService.verifyForgotPassword(data);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const ChangeForgotPassword = async (data) => {
    try {
        const response = await LoginService.changeForgotPassword(data);
        return response
    } catch (error) {
        console.log(error.message);
    }
}
export const createPaypalOrder = async (data) => {
    try {
        const response = await LoginService.createPaypalOrder(data);
        return response
    } catch (error) {
        console.log(error.message);
    }
}



export const capturePaypalOrder = async (data) => {
    try {
        const response = await LoginService.capturePaypalOrder(data);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const PaymentReport = async (page, limit, sortBy, direction) => {
    try {
        const response = await LoginService.PaymentReport(page, limit, sortBy, direction);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const getSubscriptionDetails = async () => {
    try {
        const response = await LoginService.getSubscriptionDetails();
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const manageSubscription = async (data) => {
    try {
        const response = await LoginService.manageSubscription(data);
        return response
    } catch (error) {
        console.log(error.message);
        throw error;
    }
}